<template>
    <div class="card">
        <header class="card-header">
            <router-link to="/auctions" class="card-header-title">
                TOTAL AUCTION LOTS #
            </router-link>
            <router-link to="/auctions" class="card-header-icon" aria-label="more options">
              <span class="icon has-text-danger">
                <i class="fas fa-gavel" aria-hidden="true"></i>
              </span>
            </router-link>
        </header>
        <div class="card-content">
            <table class="table is-fullwidth">
                <tr v-for="lot in lots">
                    <th>{{ getDayOfWeek(lot.date) }}:</th>
                    <td><strong class="has-text-primary">{{ lot.number }}</strong></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import apiSearch from './../../api/apiSearch'
    import moment from 'moment'
    export default {
        data () {
            return {
                lots: []
            }
        },
        methods: {
            getDayOfWeek(date){
                let week = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
                return week[moment(date).day()]
            }
        },
        mounted () {
            apiSearch
                .getLotsNumbers()
                .then((response) => {
                    this.lots = response.data
                })
                .catch((error) => {
                    console.log(error)
                })

        }
    }
</script>

<style scoped>
    .card {
        height: 255px;
    }
    th {
        font-size: small;
    }
    td {
        font-size: small;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Auctions.vue